module.exports = __webpack_public_path__ + "static/media/japan.c85d017a.svg";